import { createSlice } from "@reduxjs/toolkit";

const initialState= {
    // Email customer states
    currentDay: 0,
    dates: [],
    customerLists: [],
    dataNotFoundStatus: true,
    insightWeeks: [],
    insightData: [],
    emailsSent: [],
    emailUpdatedStatus: false,
    emailUpdatedStatusDone: [],
    companyDetails: {},
    currCustomerWeekData: [],
    companyGenericProducts: {},
    emailActivities: [],
    emailStats: [],
    page: 'page 1',

    // Email templates states
    template: 'default',
    allTemplates: [],
}

const emailCustomer = createSlice({
    name: 'emailCustomer',
    initialState,
    reducers: {

        // Email Customer states
        setCurrentDay: (state,action) => {
            state.currentDay = action.payload
        },
        setDates: (state, action) => {
            state.dates = action.payload
        },
        setCustomerLists: (state, action) => {
            state.customerLists = action.payload
        },
        updateDataAction: (state, action) => {
            state.dates = action.payload.dates
            state.customerLists = action.payload.customerLists
            state.dataNotFoundStatus = action.payload.dataNotFoundStatus
        },
        updateDataActionInsights: (state, action) => {
            state.insightWeeks = action.payload.insightWeeks
            state.insightData = action.payload.insightData
        },
        setEmailsSent: (state,action) => {
            state.emailsSent = action.payload
        },
        setEmailUpdatedStatus: (state,action) => {
            state.emailUpdatedStatus = action.payload
        },
        setEmailUpdatedStatusDone: (state,action) => {
            state.emailUpdatedStatusDone = action.payload
        },
        setExtraData: (state,action) => {
            state.currCustomerWeekData = action.payload.currCustomerWeekData
            state.companyDetails = action.payload.companyDetails
            state.companyGenericProducts = action.payload.companyGenericProducts
        },
        setEmailActivities: (state,action) => {
            state.emailActivities = action.payload
        },
        setEmailStats: (state,action) => {
            state.emailStats = action.payload
        },


        setPage: (state,action) => {
            state.page = action.payload
        },

        
        // Email templates states
        setTemplate: (state,action) => {
            state.template = action.payload
        },
        setAllTemplates: (state,action) => {
            state.allTemplates = action.payload
        },
        resetEmailSlice: (state, action) => {
            return { ...initialState };
          }

    },

    
})

export const { 
    setCurrentDay, setDates, setCustomerLists, updateDataAction, updateDataActionInsights, setEmailsSent, setEmailUpdatedStatus, setEmailUpdatedStatusDone, setExtraData, setEmailActivities, setEmailStats, setPage,
    setTemplate, setAllTemplates,resetEmailSlice
} = emailCustomer.actions

export default emailCustomer.reducer